import { render, staticRenderFns } from "./OrderBoatCreate.vue?vue&type=template&id=d94d2bea&scoped=true&"
import script from "./OrderBoatCreate.vue?vue&type=script&lang=js&"
export * from "./OrderBoatCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrderBoatCreate.vue?vue&type=style&index=0&id=d94d2bea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94d2bea",
  null
  
)

export default component.exports